<template>
  <div v-if="visible" class="image-carousel-modal" @click.prevent="close">
    <button
      class="nav-btn prev"
      @click.stop.prevent="prev"
      :disabled="currentIndex === 0"
    >
      <i class="fas fa-chevron-left fa-2x"/>
    </button>

    <img :src="images[currentIndex]" v-if="images.length" alt="Preview" />

    <button
      class="nav-btn next"
      @click.stop.prevent="next"
      :disabled="currentIndex === images.length - 1"
    >
      <i class="fas fa-chevron-right fa-2x"/>
    </button>

    <button class="close-btn" @click="close">
      <i class="fas fa-times fa-2x"/>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ImagePreviewModal',
  props: {
    images: {
      type: Array,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    index: {
      get() { return this.currentIndex; },
      set(val) { this.$emit('update:currentIndex', val); },
    },
  },
  methods: {
    next() {
      if (this.index < this.images.length - 1) {
        this.index += 1;
      }
    },
    prev() {
      if (this.index > 0) {
        this.index -= 1;
      }
    },
    close() {
      this.$emit('close');
    },
    handleKey(event) {
      if (!this.visible) return;

      // eslint-disable-next-line default-case
      switch (event.key) {
        case 'ArrowRight':
          this.next();
          break;
        case 'ArrowLeft':
          this.prev();
          break;
        case 'Escape':
          this.close();
          break;
      }
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKey);
  },
};
</script>

<style scoped>
.image-carousel-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 90%;
    max-height: 90%;
    border-radius: 8px;
    box-shadow: 0 0 15px rgba(0,0,0,0.6);
  }

  .close-btn {
    position: absolute;
    top: 15px;
    right: 25px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 10000;
  }

  .close-btn:hover {
    color: #ccc;
  }

  .nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 32px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 10000;
    user-select: none;
    padding: 10px;
    opacity: 0.8;
    transition: opacity 0.2s;
  }

  .nav-btn:hover:not(:disabled) {
    opacity: 1;
  }

  .nav-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .prev {
    left: 30px;
  }

  .next {
    right: 30px;
  }

  .nav-btn, .close-btn  i {
    color: white;
    transition: opacity 0.2s;
  }

}
</style>
